export const selectors = {
  statusLabel: '#StatusLabel',
  statusTitle: '#StatusTitle',
  statusDescription: '#StatusDescription',
} as const;
